<script lang="ts">
  import { Col, Container, Image, Row ,Card} from "sveltestrap";
  import BookmarkBlogDetails from "./BookmarkBlogDetails.svelte";
  import RightBlogDetail from "./RightBlogDetail.svelte";
  import BottomBlogDetails from "./BottomBlogDetails.svelte";
  let imgPath:string = "/assets/images/blog"
</script>
<BookmarkBlogDetails />
<Container fluid class="blog-page">
  <Row>
    <Col xxl="6" class="set-col-12 box-col-12 xl-40">
      <Card>
        <div class="blog-box blog-shadow">
          <Image fluid class="bg-img-cover" src="{imgPath}/blog.jpg" />
          <div class="blog-details">
            <p>{'9 April 2022'}</p>
            <h4>{'Perspiciatis unde omnis iste natus error sit.'}</h4>
            <ul class="blog-social">
              <li>
                <i class="icofont icofont-user" />{'Mark Jecno'}
              </li>
              <li>
                <i class="icofont icofont-thumbs-up" />{'0 Hits'}
              </li>
              <li>
                <i class="icofont icofont-ui-chat" />{'598 Comments'}
              </li>
            </ul>
          </div>
        </div>
      </Card>
    </Col>
    <RightBlogDetail />
    <BottomBlogDetails />
  </Row>
</Container>